module.exports = __webpack_public_path__ + "static/media/_ProductPurchase2.8b0d0f45.scss";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Cob/views/ProductPurchase-2/alfakraft/_ProductPurchase2.scss
// module id = 563
// module chunks = 0